import React from "react";
import SEO from "@/components/SEO";
import LiveDemoModule from "@/components/demo/LiveDemoModule";

export default function LiveDemo() {
  return (
    <>
      <SEO
        title="Live Platform Demo — A Self-Operating, Audit-Provable Quality System"
        description="Interactive LabComplyx demo: watch a self-operating CAPA, SOP, deviation, inspection readiness, validation, or AI governance lifecycle — work arrives pre-investigated at human sign-off gates with an immutable evidence trail, every guardrail enforced in real time."
        canonical="https://labcomplyx.com/demo"
      />
      <LiveDemoModule />
    </>
  );
}